import * as React from "react";
import StaticAutocomplete, {
  StaticAutocompleteWrapperPropsT,
} from "kyoto/components/Autocomplete/StaticAutocomplete";
import { CheckboxListPropsWithoutChoicesOrNameT } from "kyoto/components/Forms/Formik/choiceFields";
import ChoiceFetcher, { ChoiceRenderT } from "kyoto/components/hocs/ChoiceFetcher";

export const PublicOrganizations = (props: StaticAutocompleteWrapperPropsT): React.ReactElement => (
  <ChoiceFetcher
    entity="job_board"
    field="organizations"
    render={({ choices }: ChoiceRenderT): React.ReactElement | null => (
      <StaticAutocomplete
        multiple
        label="Company"
        name="organizations"
        placeholder="Enter a Company"
        suggestions={choices}
        uniqueById
        omitSelected
        {...props}
      />
    )}
  />
);

export const PublicClassification = ({
  multiple = true,
  ...props
}: StaticAutocompleteWrapperPropsT): React.ReactElement => (
  <ChoiceFetcher
    entity="job_board"
    field="classification"
    render={({ choices }): React.ReactElement | null => (
      <StaticAutocomplete
        name="classification"
        suggestions={choices}
        label="Field of Work"
        placeholder="Enter a Field of Work"
        multiple={multiple}
        uniqueById
        omitSelected
        {...props}
      />
    )}
  />
);

export const PublicSeniority = (props: StaticAutocompleteWrapperPropsT): React.ReactElement => (
  <ChoiceFetcher
    entity="job_board"
    field="seniority"
    render={({ choices }: ChoiceRenderT): React.ReactElement | null => (
      <StaticAutocomplete
        multiple
        label="Experience Level"
        name="seniority_scores"
        placeholder="Enter an Experience Level"
        suggestions={choices}
        uniqueById
        omitSelected
        {...props}
      />
    )}
  />
);

export const PublicLocations = (
  props: CheckboxListPropsWithoutChoicesOrNameT,
): React.ReactElement => (
  <ChoiceFetcher
    entity="job_board"
    field="locations"
    render={({ choices }: ChoiceRenderT): React.ReactElement | null => (
      <StaticAutocomplete
        label="Location"
        name="locations"
        placeholder="Enter a Location"
        suggestions={choices}
        uniqueById
        omitSelected
        {...props}
        multiple
      />
    )}
  />
);
